import React from 'react'
import { Grid2 as Grid } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'

interface DayFilterPeriodProps {
  show?: boolean
  value?: Dayjs | null
  onFilterChange?: (date: Dayjs | null) => void
}

const DayFilterPeriod: React.FC<DayFilterPeriodProps> = ({
  show,
  value,
  onFilterChange
}) => {
  if (!show) return null

  const today = dayjs()

  const handleDateChange = (newDate: Dayjs | null) => {
    if (!newDate) {
      onFilterChange?.(null)
      return
    }

    const isToday = newDate.isSame(today, 'day')

    const adjustedDate = isToday
      ? dayjs() // Horário atual se for hoje
      : newDate.hour(23).minute(59).second(59) // 23:59:59 se for outro dia

    onFilterChange?.(adjustedDate)
  }

  return (
    <Grid size={12} padding={2} container justifyContent={'end'}>
      <DatePicker
        label='Escolher dia'
        value={value}
        onChange={handleDateChange}
        maxDate={dayjs()}
      />
    </Grid>
  )
}

export default DayFilterPeriod
